import { useMemo } from 'react';
import { Clip } from '@/player-config/src/types/clip-types';
import { doesClipHaveThumbnail } from '@/player-config/src/utils/clipUtils';

export const useRemotionThumbnail = ({ clip }: { clip: Clip }) => {
  const canUseRemotionThumbnail = useMemo(() => {
    return doesClipHaveThumbnail(clip);
  }, [clip]);

  return { canUseRemotionThumbnail };
};
